import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Grid,
  Box,
  Typography,
  Container,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { Formik } from "formik";

import { forgotPassword } from "../../../api/axios";
import { Copyright } from "../../../components/copyright/Copyright";
import SnackBar from "../../../components/snackbar/SnackBar";
import { useState } from "react";

const theme = createTheme();

export default function ForgotPassword() {
  const { t } = useTranslation();

  const checkoutSchema = yup.object().shape({
    email: yup.string().email("invalid email").required("Email Required"),
  });

  const initialValues = {
    email: "",
  };

  const [isLoading, setIsLoading] = useState(false);
  const [messageSnk, setMessageSnk] = useState("");
  const [stateSnk, setStateSnk] = useState(false);
  const [severity, setSeverity] = useState("success");
  const vertical = "top";
  const horizontal = "center";
  const handleSnkClose = () => {
    setStateSnk(false);
  };
  const snackBarDialog = (message, severity = "success") => {
    setMessageSnk(message);
    setSeverity(severity);
    setStateSnk(true);
  };

  const handleFormSubmit = async (values) => {
    setIsLoading(true);
    try {
      await forgotPassword(values.email);
      snackBarDialog("CODIGO ENVIADO A SU CORREO");
      setIsLoading(false);
    } catch (err) {
      console.log(err)
      snackBarDialog("ERROR, NO SE HA PODIDO VERIFICAR EL CORREO", "error");
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={`../../assets/logo.png`}
            style={{ width: 152, height: 152 }}
            alt="Logo"
          />

          <Typography component="h1" variant="h5">
            Taxi Mundo
          </Typography>
          <Box>
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              validationSchema={checkoutSchema}
            >
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box gap="10px" sx={{ margin: "4px" }}>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          value={values.email}
                          fullWidth
                          id="email"
                          type="email"
                          required
                          label="Email"
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.email && !!errors.email}
                          helperText={touched.email && errors.email}
                          autoComplete="email"
                          autoFocus
                        />
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{ mb: 2 }}
                          disabled={isLoading}
                        >
                          {t("resetPassword")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* <Box display="flex">
                    <CodeSuccess />
                  </Box> */}
                  {/* <Box display="grid" gap="5px" sx={{ margin: "4px" }}>
                    <TextField
                      margin="normal"
                      type="password"
                      required
                      fullWidth
                      id="password"
                      label="New Password"
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.password}
                      error={!!touched.new_password && !!errors.new_password}
                      helperText={touched.new_password && errors.new_password}
                    />
                  </Box>

                  <Box display="grid" gap="5px" sx={{ margin: "4px" }}>
                    <TextField
                      margin="normal"
                      type="password"
                      required
                      fullWidth
                      id="new_password"
                      label="Confirm password"
                      name="new_password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.new_password}
                      error={!!touched.new_password && !!errors.new_password}
                      helperText={touched.new_password && errors.new_password}
                    />
                  </Box> */}

                  <Grid container justifyContent="end">
                    <Grid item>
                      <Link to="/login">{t("singin")}</Link>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </Box>
        </Box>
        <SnackBar
          stateSnk={stateSnk}
          vertical={vertical}
          horizontal={horizontal}
          duration={5000}
          handleClose={handleSnkClose}
          severity={severity}
          messageSnk={messageSnk}
        />
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
